import type { grsaiModelConfig } from './types';
import { openaiConfigs } from './configs/openai';
import { googleConfigs } from './configs/google';
import { wrappedConfigs } from './configs/wrapped';

export const grsaiModelConfigs: Record<string, grsaiModelConfig> = {
    ...openaiConfigs,
    ...googleConfigs,
    ...wrappedConfigs,
};